
<component :is="tag" :class="classes" :datetime="isoDate">
  {{printDate}}
</component>
